// ── imports explicites (C4 — générés par esm-codemod --analyze, maintenus à la main) ──
import { useEffect } from "../00-boot.jsx";
import { rpcTouchPresence } from "../07-trust-moderation.jsx";
import { lanacSupabaseClient } from "../08-supabase-client.jsx";
import { membrePresent, presenceAbonner, PRESENCE_BATTEMENT_MS } from "./usePresence.jsx";
// Présence : heartbeat léger (écriture seule via RPC touch_presence). A36 · 2b (11/10/2026) : gaté par la PRÉSENCE du membre
// (usePresence : écran visible ET un geste depuis moins de dix minutes), plus seulement par la visibilité de l'onglet — un
// écran laissé allumé ne dit plus « présent » pendant des heures. Il bat toutes les 45 s (sous la fenêtre de 60 s du
// serveur : à 90 s, un membre ACTIF passait pour absent un tiers du temps), bat AUSSITÔT au retour (le rattrapage), et dit
// « au revoir » (presence_bye) dès que le membre devient absent — l'écran caché, ou dix minutes sans geste —, pour que la
// notification poussée parte sans attendre. Aucune lecture ici. App fermée ⇒ pas de heartbeat ⇒ « absent ».
function usePresenceHeartbeat(me){
  useEffect(()=>{
    const client=lanacSupabaseClient();
    if(!client||!me?.id||typeof document==="undefined") return;
    let stopped=false;
    const beat=()=>{ if(stopped||!membrePresent()) return;
      // Fix B egress (11/07) : battement conditionné à une session réelle — un onglet à session expirée
      // battait en 401 toutes les 90 s, sans fin (observé en prod). getSession() est locale (réseau
      // seulement si un refresh est dû) ; réponse ferme « pas de session » → pas d'appel réseau du tout.
      try{client.auth.getSession().then(({data})=>{ if(stopped||!data?.session) return; try{const q=rpcTouchPresence();q&&q.then&&q.then(undefined,()=>{});}catch(_){} },()=>{});}catch(_){} }; // TECH-RPC-1 : passerelle (session pré-vérifiée par l'app
    // 12/07 : « au revoir » de présence au passage en arrière-plan (RPC presence_bye).
    // Sans lui, un push arrivant < 60 s après la sortie était supprimé (« encore présent »).
    // fetch keepalive (survit à la fermeture de la page) + token lu en synchrone dans le
    // storage supabase-js — un handler pagehide ne peut pas attendre getSession().
    const bye=()=>{ try{
      const url=(window.LANAC_SUPABASE_URL||"").replace(/\/$/,"");
      if(!url) return;
      const ref=(url.match(/^https?:\/\/([^.]+)\./)||[])[1]||"";
      let tok=null;
      try{ const raw=localStorage.getItem("sb-"+ref+"-auth-token"); const j=raw?JSON.parse(raw):null; tok=(j&&(j.access_token||(j.currentSession&&j.currentSession.access_token)))||null; }catch(_){}
      if(!tok) return;
      fetch(url+"/rest/v1/rpc/presence_bye",{method:"POST",keepalive:true,headers:{"Content-Type":"application/json","apikey":window.LANAC_SUPABASE_ANON_KEY||"","Authorization":"Bearer "+tok},body:"{}"}).catch(()=>{});
    }catch(_){} };
    beat();
    const iv=setInterval(beat,PRESENCE_BATTEMENT_MS);
    // le membre devient présent : un battement tout de suite ; absent (écran caché, ou dix minutes sans geste) : « au revoir »
    const off=presenceAbonner((present)=>{ if(stopped) return; if(present) beat(); else bye(); });
    window.addEventListener("pagehide",bye);
    // au démontage (le compte change, se déconnecte) : « au revoir » aussi — avant, le membre parti restait « présent » 60 s
    return ()=>{ stopped=true; clearInterval(iv); off(); window.removeEventListener("pagehide",bye); bye(); };
  },[me?.id]);
}
export { usePresenceHeartbeat };
